"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAsyncConnection = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const types_1 = require("./types");
const buildAsyncConnectionConfig = (apiCall) => ({
    mode: web_ui_framework_1.AsyncConnectionMode.POLLING,
    pollingConfig: {
        interval: 5000,
        maxAttempts: 180,
        getDataFn: () => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield apiCall();
            return response.data;
        }),
    },
});
const buildAsyncConnectionEvents = (verifyActions) => ({
    onReceiveData: response => {
        verifyActions.onSuccess(response.message, types_1.AssistedLoginVerifyModeType.POLLING);
    },
    onError: () => verifyActions.onError(undefined, types_1.AssistedLoginVerifyModeType.POLLING),
});
const getAsyncConnection = (_a) => __awaiter(void 0, [_a], void 0, function* ({ apiCall, verifyActions, }) {
    const asyncConnection = new web_ui_framework_1.AsyncConnection(buildAsyncConnectionConfig(apiCall));
    const connection = asyncConnection.getConnection();
    yield connection.connect();
    connection.listen(buildAsyncConnectionEvents(verifyActions));
    return connection;
});
exports.getAsyncConnection = getAsyncConnection;
//# sourceMappingURL=biometricValidation.helper.js.map